"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Error = _interopRequireDefault(require("../Error"));

var _form = require("@jsluna/form");

var _grid = require("@jsluna/grid");

var _lodash = require("lodash");

var _uuid = require("uuid");

var _utils = require("../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ChecklistRenderer = function ChecklistRenderer(_ref) {
  var items = _ref.items,
      selectedItems = _ref.selectedItems,
      currentItem = _ref.currentItem,
      onChangeItem = _ref.onChangeItem,
      disabled = _ref.disabled,
      error = _ref.error;
  if (!items) return null;
  (0, _react.useEffect)(function () {
    return sortedItems;
  }, [items, selectedItems]);
  var sortedItems = items.sort(function (a, b) {
    return a.position - b.position;
  });

  var CurrentItemSelected = function CurrentItemSelected(value, idx) {
    var existingItem = selectedItems.find(function (x) {
      return x.itemId === value;
    });

    if (existingItem) {
      switch (idx) {
        case 0:
          return existingItem.itemId;

        case 1:
          return existingItem.selected;

        case 2:
          return existingItem.userName;

        case 3:
          return existingItem.formattedDateTime;

        default:
          break;
      }
    }

    return '';
  };

  var handleSetResponse = function handleSetResponse(val, check) {
    var newResponse = [].concat(selectedItems.filter(function (x) {
      return x.itemId !== val;
    }), [{
      itemId: val,
      selected: check,
      userId: '',
      userName: '',
      dateTime: ''
    }]);
    var filteredResponse = (0, _lodash.uniq)(newResponse.filter(function (item) {
      return item.itemId !== '';
    }));
    onChangeItem(filteredResponse);
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, sortedItems.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-u-padding-bottom*2"
  }, sortedItems.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/1",
      key: (0, _uuid.v1)()
    }, /*#__PURE__*/_react.default.createElement(_form.Checkbox, {
      key: "" + item.id,
      fullWidth: true,
      outlined: true,
      name: item.id + "-checklist",
      checked: selectedItems && CurrentItemSelected(item.id, 1),
      value: item.id,
      disabled: disabled,
      onChange: function onChange(e) {
        return handleSetResponse(e.target.value, !CurrentItemSelected(item.id, 1));
      },
      label: (0, _utils.renderTextWithLinks)(item.text),
      className: error && currentItem === item.id ? 'checklist-error-checkbox' : 'checklist-item-checkbox-border'
    }), selectedItems && CurrentItemSelected(item.id, 0) === item.id && /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: {
        default: '1/1',
        sm: '1/2'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "response-bar"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: disabled ? 'checklist-message-disabled' : 'checklist-message-span'
    }, CurrentItemSelected(item.id, 2), " updated on", ' ', CurrentItemSelected(item.id, 3)))), error && currentItem === item.id && /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/1"
    }, /*#__PURE__*/_react.default.createElement(_Error.default, {
      className: "ln-u-margin-bottom*2 ln-u-padding-top*2",
      message: "There was a problem adding a response, please try again!"
    })));
  }))));
};

ChecklistRenderer.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    position: _propTypes.default.number.isRequired
  })),
  selectedItems: _propTypes.default.array,
  currentItem: _propTypes.default.string,
  onChangeItem: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool
};
ChecklistRenderer.defaultProps = {
  items: [],
  selectedItems: [],
  currentItem: '',
  disabled: false,
  error: false
};
var _default = ChecklistRenderer;
exports.default = _default;